<script setup>
import { ref, computed } from 'vue';
import { useStore } from 'vuex';

const store = useStore();
const isLoggedIn = computed(() => store.getters.isLoggedIn);
const isMenuOpen = ref(false);

const toggleMenu = () => {
  isMenuOpen.value = !isMenuOpen.value;
};
</script>

<template>
  <header
    class="bg-surface-glass font-label-md text-label-md docked full-width top-0 sticky backdrop-blur-md border-b border-outline-variant z-50"
  >
    <div
      class="flex justify-between items-center px-4 md:px-margin-desktop w-full max-w-container-max mx-auto h-20 text-left"
    >
      <div class="flex items-center gap-stack-lg">
        <router-link
          to="/"
          class="flex items-center"
        >
          <img
            src="/brand-assets/logo_horizontal.png"
            alt="OS DESK"
            class="h-12 w-auto"
          />
        </router-link>
        <nav class="hidden md:flex gap-stack-lg">
          <router-link
            to="/features"
            class="text-on-surface-variant hover:text-primary transition-colors font-semibold"
            active-class="text-primary border-b-2 border-secondary pb-1"
          >
            Products
          </router-link>
          <router-link
            to="/customers"
            class="text-on-surface-variant hover:text-primary transition-colors font-semibold"
            active-class="text-primary border-b-2 border-secondary pb-1"
          >
            Solutions
          </router-link>
          <router-link
            to="/workflow"
            class="text-on-surface-variant hover:text-primary transition-colors font-semibold"
            active-class="text-primary border-b-2 border-secondary pb-1"
          >
            Intelligence
          </router-link>
          <router-link
            to="/pricing"
            class="text-on-surface-variant hover:text-primary transition-colors font-semibold"
            active-class="text-primary border-b-2 border-secondary pb-1"
          >
            Pricing
          </router-link>
          <router-link
            to="/aerox"
            class="text-on-surface-variant hover:text-primary transition-colors font-semibold"
            active-class="text-primary border-b-2 border-secondary pb-1"
          >
            Aerox
          </router-link>
        </nav>
      </div>

      <!-- Desktop Actions -->
      <div class="hidden md:flex items-center gap-stack-md">
        <router-link
          v-if="isLoggedIn"
          to="/app"
          class="text-on-surface hover:text-primary transition-colors px-stack-md py-stack-sm font-semibold"
        >
          Console
        </router-link>
        <router-link
          v-else
          to="/app/login"
          class="text-on-surface hover:text-primary transition-colors px-stack-md py-stack-sm font-semibold"
        >
          Login
        </router-link>

        <router-link
          to="/book-demo"
          class="bg-primary text-on-primary px-stack-lg py-stack-sm rounded-lg font-semibold hover:opacity-90 transition-all text-center"
        >
          Get a Demo
        </router-link>
      </div>

      <!-- Mobile Hamburger Button -->
      <div class="md:hidden flex items-center">
        <button
          class="text-deep-navy dark:text-white focus:outline-none p-2 rounded-lg hover:bg-surface-container transition-colors"
          aria-label="Toggle menu"
          @click="toggleMenu"
        >
          <span class="material-symbols-outlined text-[28px]">{{
            isMenuOpen ? 'close' : 'menu'
          }}</span>
        </button>
      </div>
    </div>

    <!-- Mobile Menu Dropdown -->
    <div
      v-if="isMenuOpen"
      class="md:hidden border-t border-outline-variant bg-white dark:bg-deep-navy py-4 px-6 space-y-4 shadow-xl"
    >
      <nav class="flex flex-col space-y-3">
        <router-link
          to="/features"
          class="text-on-surface-variant hover:text-primary transition-colors font-semibold text-body-md py-2 border-b border-outline-variant/30"
          active-class="text-primary"
          @click="isMenuOpen = false"
        >
          Products
        </router-link>
        <router-link
          to="/customers"
          class="text-on-surface-variant hover:text-primary transition-colors font-semibold text-body-md py-2 border-b border-outline-variant/30"
          active-class="text-primary"
          @click="isMenuOpen = false"
        >
          Solutions
        </router-link>
        <router-link
          to="/workflow"
          class="text-on-surface-variant hover:text-primary transition-colors font-semibold text-body-md py-2 border-b border-outline-variant/30"
          active-class="text-primary"
          @click="isMenuOpen = false"
        >
          Intelligence
        </router-link>
        <router-link
          to="/pricing"
          class="text-on-surface-variant hover:text-primary transition-colors font-semibold text-body-md py-2 border-b border-outline-variant/30"
          active-class="text-primary"
          @click="isMenuOpen = false"
        >
          Pricing
        </router-link>
        <router-link
          to="/aerox"
          class="text-on-surface-variant hover:text-primary transition-colors font-semibold text-body-md py-2 border-b border-outline-variant/30"
          active-class="text-primary"
          @click="isMenuOpen = false"
        >
          Aerox
        </router-link>
      </nav>
      <div class="flex flex-col gap-3 pt-2">
        <router-link
          v-if="isLoggedIn"
          to="/app"
          class="text-center text-on-surface hover:text-primary transition-colors py-3 font-semibold border border-outline rounded-lg"
          @click="isMenuOpen = false"
        >
          Console
        </router-link>
        <router-link
          v-else
          to="/app/login"
          class="text-center text-on-surface hover:text-primary transition-colors py-3 font-semibold border border-outline rounded-lg"
          @click="isMenuOpen = false"
        >
          Login
        </router-link>
        <router-link
          to="/book-demo"
          class="bg-primary text-on-primary py-3 rounded-lg font-semibold hover:opacity-90 transition-all text-center"
          @click="isMenuOpen = false"
        >
          Get a Demo
        </router-link>
      </div>
    </div>
  </header>
</template>
